import React, { useEffect } from "react";
import digitConverter from "../../../utils/digitConverter";
import thConverter from "../../../utils/thConverter";

const SeeratLBRow = ({ merit, student, setMyPosition, mySn, level }) => {
  useEffect(() => {
    if (student.sn === mySn) {
      setMyPosition(merit + 1);
    }
  }, [student.sn, mySn, merit, setMyPosition, level]);

  return (
    <tr className=" ">
      <th className="bg-green-100 font-bold">
        {digitConverter(merit + 1)} <sup>{thConverter(merit + 1)}</sup>
      </th>
      <th>{student?.sn}</th>
      <td>{student?.name.toUpperCase()}</td>
      {level === "2" && (
        <>
          <th>{student?.seerat2data[0]?.Score}</th>
          <th>{student?.seerat2data[1]?.Score}</th>
          <th>{student?.seerat2data[2]?.Score}</th>
          <th className="bg-red-100 text-red-600">{student?.seerat2Total}</th>
        </>
      )}
      {level === "1" && (
        <>
          <th>{student?.seerat1data[0]?.Score}</th>
          <th>{student?.seerat1data[1]?.Score}</th>
          <th>{student?.seerat1data[2]?.Score}</th>
          <th className="bg-red-100 text-red-600">{student?.seerat1Total}</th>
        </>
      )}
    </tr>
  );
};

export default SeeratLBRow;
